import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Inbox } from "lucide-react";
import { api, loadAuthToken } from "../lib/api";
import { fmtDate } from "../lib/customers";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { STAFF_PATHS } from "./followups";

export const NotificationBell = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const authed = STAFF_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/")) && pathname !== "/admin/login" && !!loadAuthToken() && !!localStorage.getItem("ap_admin_user");

  useEffect(() => {
    if (!authed) { setItems([]); return; }
    const load = () => api.get("/notifications").then((r) => setItems(r.data || [])).catch(() => {});
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, [authed]);

  if (!authed) return null;
  const unread = items.filter((n) => n.unread).length;
  const markAll = async () => { await api.post("/notifications/read-all").catch(() => {}); setItems(items.map((n) => ({ ...n, unread: false }))); };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative p-2 rounded-md border border-slate-200 text-slate-700 hover:bg-slate-50" aria-label="Notifications" data-testid="notif-bell">
          <Inbox className="w-4 h-4" />
          {unread > 0 && <span data-testid="notif-count" className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-teal-600 text-white text-[10px] font-bold flex items-center justify-center">{unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notif-panel">
        <div className="flex items-center justify-between px-3 py-2 border-b text-sm font-semibold">Notifications
          {unread > 0 && <button onClick={markAll} className="text-xs text-teal-700 hover:underline" data-testid="notif-read-all">Sab padh liya</button>}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 && <div className="p-4 text-sm text-slate-500 text-center">Koi notification nahi</div>}
          {items.map((n) => (
            <button key={n.id} onClick={() => n.customer_id && navigate(`/admin/customers/${n.customer_id}`)} data-testid={`notif-${n.id}`}
              className={`w-full text-left px-3 py-2 border-b border-slate-100 hover:bg-slate-50 ${n.unread ? "bg-teal-50/60" : ""}`}>
              <div className="text-sm font-medium text-slate-900">{n.title}</div>
              <div className="text-xs text-slate-600">{n.body}</div>
              <div className="text-[10px] text-slate-400 mt-0.5">{fmtDate(n.created_at, true)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
